import CommonOperationClass from '../../commonOperationClass';

const calculate = new CommonOperationClass('=');

export default calculate;
